import React from 'react';
import { Table } from '@gerdau/hefesto-mais-web';
import { IDuplicatesByDayData } from '..';
import { formatCurrency } from '../../../../../utils/formatNumbers';

interface IDuplicatesByDayChartProps {
  data: IDuplicatesByDayData[];
  allProductsDescription: string[];
}

const DuplicatesByDayTable: React.FC<IDuplicatesByDayChartProps> = ({
  data,
  allProductsDescription
}) => {
  const getColumns = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const columns: any = [
      {
        title: <b>Status</b>,
        dataIndex: 'duplicateStatus',
        fixed: 'left' as const,
        render: (text: string) => <>{text}</>
      },
      {
        title: <b>Total</b>,
        dataIndex: 'total',
        fixed: 'left' as const,
        align: 'center' as const,
        render: (text: string) => <>{formatCurrency(text)}</>
      }
    ];

    data.forEach((item) => {
      columns.push({
        title: item.date,
        dataIndex: item.date,
        align: 'center' as const,
        render: (text: string) => <>{formatCurrency(text)}</>
      });
    });

    return columns;
  };

  const tableData = [];

  let totalsRow = {
    key: 0,
    duplicateStatus: 'Total diário',
    total: data.reduce(
      (acc, curr) =>
        curr.duplicates.reduce(
          (accDuplicatesSum, currDuplicate) =>
            currDuplicate.totalInvoice + accDuplicatesSum,
          0
        ) + acc,
      0
    )
  };
  data.forEach((item) => {
    totalsRow = {
      ...totalsRow,
      [item.date]: item.duplicates.reduce(
        (accDuplicatesSum, currDuplicate) =>
          currDuplicate.totalInvoice + accDuplicatesSum,
        0
      )
    };
  });
  tableData.push(totalsRow);

  allProductsDescription.forEach((duplicateStatus, idx) => {
    let row = {
      key: idx + 1,
      duplicateStatus: duplicateStatus,
      total: data.reduce(
        (acc, curr) =>
          acc +
          (curr.duplicates.find((i) => i.status === duplicateStatus)
            ?.totalInvoice || 0),
        0
      )
    };

    data.forEach((item) => {
      row = {
        ...row,
        [item.date]:
          item.duplicates.find((i) => i.status === duplicateStatus)
            ?.totalInvoice || 0
      };
    });

    tableData.push(row);
  });

  return (
    <Table
      scroll={{
        x: true
      }}
      columns={getColumns()}
      dataSource={tableData}
    />
  );
};

export default DuplicatesByDayTable;
